import GLightbox from 'glightbox';

export default class Lightbox {
	constructor() {
		const lightbox = GLightbox({
			touchNavigation: true,
			loop: true,
			autoplayVideos: true,
			plyr: {
				css: 'https://cdn.plyr.io/3.7.3/plyr.css',
				js: 'https://cdn.plyr.io/3.7.3/plyr.js',
				config: {
					muted: false,
					hideControls: true,
					youtube: {
						noCookie: true,
						rel: 0,
						showinfo: 0,
					},
				},
			},
		});

		window['glightbox'] = lightbox;
	}
}
